import { SelectedGradeActionType } from '../actionTypes/selectedGrade';
import { PostDispatch } from '../types';

export interface SelectedGradeState {
    selectedScoringTotalPoints: number | null;
    selectedPresentationTotalPoints: number | null;
    disabled?: boolean;
}

const INITIAL_SELECTED_GRADE_STATE: SelectedGradeState = {
    selectedScoringTotalPoints: null,
    selectedPresentationTotalPoints: null,
};

const SelectedGradeReducer = (
    state = INITIAL_SELECTED_GRADE_STATE,
    action: PostDispatch
): SelectedGradeState => {
    const getPayload = action.payload as SelectedGradeState;
    switch (action.type) {
        case SelectedGradeActionType.SET_SELECTED_GRADE:
            return {
                ...state,
                ...getPayload,
            };
        default:
            return state;
    }
};

export default SelectedGradeReducer;
